import React, { useState, useEffect } from "react";
import axios from "axios";
import moment from "moment";
import { Link, useHistory, NavLink } from "react-router-dom";
import withAuth from "../../components/auth";
import { FormattedMessage, injectIntl } from "react-intl";
// import BannherEvento1 from "../../assets/images/v2/banner-chamadas-2022.jpg";
import NoImageChamada from "../../assets/images/v2/event/image-event-test.jpg";

function GamesPendingEvents({ intl }) {
  const locale = intl.locale;
  const [eventos, setEventos] = useState([]);

  useEffect(() => {
    let url = "/api/v1/events/pending";
    axios
      .get(url, {
        headers: {
          "x-access-token": localStorage.getItem("token"),
          "Cache-Control": "no-cache",
          Pragma: "no-cache",
          Expires: "0",
        },
      })
      .then((res) => {
        setEventos(res.data);
      })
      .catch((error) => {
        if (error.response.status === 401) {
          localStorage.removeItem("token");
          window.open("/", "_self");
        }
      });
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  function traducaoSiglaLocale(locale1, locale2) {
    let l1 = locale1;
    let l2 = locale2;

    if (locale1.indexOf("-") >= 0) l1 = locale1.split("-")[0];

    if (locale2.indexOf("-") >= 0) l2 = locale2.split("-")[0];

    return l1 == l2;
  }

  return (
    <div className="content-body">
      <div className="container-fluid">
        <div className="row page-titles">
          <div className="col p-0">
            <h4>
              <FormattedMessage id="app.welcome-1" />,{" "}
              <span>
                <FormattedMessage id="app.welcome-2" />
              </span>
            </h4>
          </div>
          <div className="col p-0">
            <ol className="breadcrumb">
              <li className="breadcrumb-item active">
                <FormattedMessage id="inscriptions.calls" />
              </li>
            </ol>
          </div>
        </div>
        <div className="row chamadas">
          {eventos.length !== 0 &&
            eventos.map((evento, key) => {
              console.log(evento.translations);
              let localeData = evento.translations.filter((e) =>
                traducaoSiglaLocale(e.locale, locale)
              );
              localeData = localeData.length > 0 ? localeData[0] : null;
              return (
                <div className="col-lg-6" key={key}>
                  <div className="card">
                    <div className="card-body">
                      <a
                        href={`/games-pending/${evento.id}`}
                        title={evento.name}
                      >
                        <div className="content-chamada">
                          <figure>
                            <img
                              src={evento.image ? evento.image : NoImageChamada}
                              alt={evento.name}
                            />
                          </figure>
                          <div className="text-chamada">
                            <h3>{evento.name}</h3>
                            <div
                              dangerouslySetInnerHTML={{
                                __html: localeData?.description,
                              }}
                            />
                            <h4>
                              <FormattedMessage id="inscriptions.game.limit" />
                            </h4>
                            <p>
                              {moment(evento.limit_existence_game).format(
                                "DD/MMMM/YYYY"
                              )}
                            </p>
                          </div>
                        </div>
                      </a>
                    </div>
                  </div>
                </div>
              );
            })}
        </div>
      </div>
    </div>
  );
}

export default injectIntl(withAuth(GamesPendingEvents));
